var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","link":"","elevation":"0","color":"primary","loading":_vm.loading},on:{"click":_vm.initiateCheckoutSession}},[_vm._v(" Buy Credits ")])
}
var staticRenderFns = []

export { render, staticRenderFns }